var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "preview-sp",
    { staticClass: "pega-sp-print-area" },
    [
      _c("job-search-preview-detail-sp", {
        attrs: {
          "job-search-result": _vm.jobSearchResult,
          "employment-status": _vm.jobSearchResult.employmentStatus,
          "pr-codes": _vm.jobSearchResult.prCodes,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }